import type { TimeEntry, TimeEntryLocation } from "../types";

export const FAR_DISTANCE_M = 300;

export type PunchKind = "in" | "out";

export interface PunchLocation {
	kind: PunchKind;
	location: TimeEntryLocation;
}

export function toCoordinate(
	value: number | string | null | undefined,
): number | undefined {
	if (value == null || value === "") return undefined;
	const parsed = typeof value === "number" ? value : Number(value);
	return Number.isFinite(parsed) ? parsed : undefined;
}

export function formatDistance(meters: number | null | undefined): string {
	if (meters == null || !Number.isFinite(meters) || meters < 0) return "";
	const rounded = Math.round(meters);
	if (rounded < 1000) return `a ${rounded} m do canteiro`;
	const km = (meters / 1000).toLocaleString("pt-BR", {
		minimumFractionDigits: 1,
		maximumFractionDigits: 1,
	});
	return `a ${km} km do canteiro`;
}

export function isFar(meters: number | null | undefined): boolean {
	return meters != null && meters > FAR_DISTANCE_M;
}

export function punchLocations(entry: TimeEntry): PunchLocation[] {
	const punches: PunchLocation[] = [];
	if (entry.clockInLocation) {
		punches.push({ kind: "in", location: entry.clockInLocation });
	}
	if (entry.clockOutLocation) {
		punches.push({ kind: "out", location: entry.clockOutLocation });
	}
	return punches;
}

export function farthestDistance(punches: PunchLocation[]): number | null {
	let farthest: number | null = null;
	for (const punch of punches) {
		const distance = punch.location.distanceM;
		if (distance == null) continue;
		if (farthest == null || distance > farthest) farthest = distance;
	}
	return farthest;
}
